import React from 'react';
import CardBackAge1 from '../assets/card_images/CardBackAge1.jpg';
import CardBackAge2 from '../assets/card_images/CardBackAge2.jpg';
import CardBackAge3 from '../assets/card_images/CardBackAge3.jpg';
import CardBackBasicBuilding from '../assets/card_images/CardBackBasicBuilding.jpg';
import CardBackBasicEvent from '../assets/card_images/CardBackBasicEvent.jpg';
import CardBackBasicUnit from '../assets/card_images/CardBackBasicUnit.jpg';
import CardBackTribute from '../assets/card_images/CardBackTribute.jpg';
import BaseCardView from './BaseCardView';

export type CardBack = {
  type: CardBackType;
  id: string;
};
export type CardBackType =
  | 'age1'
  | 'age2'
  | 'age3'
  | 'tribute'
  | 'basic1'
  | 'basic2'
  | 'basic3'
  | 'basicunit'
  | 'basicbuilding'
  | 'basicevent';
export type CardBackEventFunc = (card: CardBack, event: MouseEvent) => void;

type CardBackProps = {
  card: CardBack;
  onLeftClick?: CardBackEventFunc;
  onCardEnter?: CardBackEventFunc;
  onCardLeave?: CardBackEventFunc;
  overlayStyle?: React.CSSProperties;
};
export const CardBackView = React.forwardRef<HTMLDivElement, CardBackProps>(
  (props, ref) => {
    const desc = TypeToCardBackDesc[props.card.type];
    return (
      <BaseCardView
        ref={ref}
        landscape={props.card.type === 'tribute'}
        onLeftClick={(e: any) => props.onLeftClick?.(props.card, e)}
        onMouseEnter={(e: any) => props.onCardEnter?.(props.card, e)}
        onMouseLeave={(e: any) => props.onCardLeave?.(props.card, e)}
        cardStyle={{
          backgroundImage: `url(${desc.image})`,
          backgroundPositionX: 'center',
          backgroundPositionY: 'center',
          backgroundSize: '100% 100%',
          border: 'none',
          boxShadow: 'none',

          filter: desc.filter,
        }}
        overlayStyle={props.overlayStyle}
      ></BaseCardView>
    );
  },
);

type CardBackDesc = {
  image: string;
  filter?: string;
};
function cbd(image: string, filter?: string): CardBackDesc {
  return {
    image,
    filter,
  };
}

const BasicFilter = 'brightness(0.7) grayscale(100%) sepia(100%)';
const TypeToCardBackDesc: Record<CardBackType, CardBackDesc> = {
  age1: cbd(CardBackAge1),
  age2: cbd(CardBackAge2),
  age3: cbd(CardBackAge3),
  tribute: cbd(CardBackTribute),
  basic1: cbd(CardBackAge1, BasicFilter),
  basic2: cbd(CardBackAge2, BasicFilter),
  basic3: cbd(CardBackAge3, BasicFilter),
  basicunit: cbd(CardBackBasicUnit),
  basicbuilding: cbd(CardBackBasicBuilding),
  basicevent: cbd(CardBackBasicEvent),
};
